export default __webpack_public_path__ + "static/media/@hannakatieli.82add8da.jpg";